module.exports = {"350622100":"云陵镇","350622101":"陈岱镇","350622102":"东厦镇","350622103":"莆美镇","350622104":"列屿镇","350622105":"火田镇","350622200":"下河乡","350622201":"马铺乡","350622202":"和平乡","350622500":"常山华侨经济开发区","350622501":"云陵工业开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350622.json
// module id = 1211
// module chunks = 0